export default "__VITE_ASSET__Bz5Kugjj__"